import {useEffect, useState} from 'react';
import {IUserAgent} from '../../common/type';
import {getIsLiteVersion} from '../../common/util/userAgent';

export default function useIsLite(userAgent?: IUserAgent) {
  const [isLite, setIsLite] = useState(false);
  useEffect(() => {
    setIsLite(getIsLiteVersion(userAgent));
  }, [userAgent]);
  return isLite;
}
